// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getMonthlyPayments = createAsyncThunk('monthlyPayments/getMonthlyPayments', async (month) => {
  const response = await axios.get(`/v1/monthly-payments/${month}`)
  return response.data
})

export const importFile = createAsyncThunk('monthlyPayments/importFile', async ({ month, file }) => {
  const formData = new FormData()
  formData.append("file", file)

  const response = await axios.post(
    `/v1/monthly-payments/${month}/import`,
    formData,
    {
        headers: {
            "Content-type": "multipart/form-data"
        }          
    }
)
  return response.data
})

export const appMonthlyPaymentsSlice = createSlice({
  name: 'monthlyPayments',
  initialState: {
    monthlyPayments: [],
    allMonths: [],
    isLoading: false
  },
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(getMonthlyPayments.pending, (state) => {
        state.isLoading = true
        state.monthlyPayments = []
        state.allMonths = []
      })
      .addCase(getMonthlyPayments.fulfilled, (state, action) => {
        state.monthlyPayments = action.payload.monthlyPayments
        state.allMonths = action.payload.allMonths
        state.isLoading = false
      })
      .addCase(importFile.fulfilled, (state, action) => {
        state.monthlyPayments = action.payload.monthlyPayments
        state.allMonths = action.payload.allMonths
        state.isLoading = false
      })
  }
})

export default appMonthlyPaymentsSlice.reducer
